import React, { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./css/default.css";
import image_logo from "./img/logo_ag.png";
import { jwtDecode } from "jwt-decode";
import { decodeScript } from "../EncryptData";
//import { wait } from "@testing-library/user-event/dist/utils";
//import { decode as base64_decode, encode as base64_encode } from "base-64";

function Index() {
    const navigate = useNavigate();
    const [choicesList, setChoicesList] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [sessionId, setSessionId] = useState(0);
    const [sessionName, setSessionName] = useState("");
    const [times, setTimes] = useState("");
    const [start_time, setStartTime] = useState("");
    const [dataDB, setDataDB] = useState([]);
    const [ dataSession, setDataSession ] = useState([]);
    const [ status, setStatus ] = useState(1);
    const [ user, setUser ] = useState([]);
    let users;
    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get("tokens");
        if (token != null) {
            const userInfo = jwtDecode(token);
            //console.log("Thông tin người dùng từ JWT:", userInfo);
            window.saveToStorage("user-info", JSON.stringify(userInfo));
            window.indexDB.initDB(userInfo.id).then(); //() => console.log("✅ IndexedDB đã khởi tạo!"));
            users = JSON.parse(window.getFromStorage("user-info"));
            setUser(users);
            navigate("/results");
        } else if (window.getFromStorage("user-info") && window.getFromStorage("user-info") !== "null") {
            navigate("/results");
            users = JSON.parse(window.getFromStorage("user-info"));
            setUser(users);
            //getChoicesPeopleList(decodeScript(rawValue));
            getDashboard(1);
        }
        else{
            navigate("/results_login");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = (e) => {
        setSelectedId(Number(e.target.value));
    };
    // async function getChoicesPeopleList(session_id = 0) {
    //     //if (parseInt(session_id + 0) !== 0) {
    //         const result = await window.fetchWithAuth("vote_sessions/getChoicesPeopleList/"+users.id_staff+"/"+session_id);
    //         const results = await result.json();
    //         const kq = results.data;
    //         setChoicesList(results.data);
    //         if(Object.keys(results.data).length !== 0){
    //             setSessionId(kq[0].session_id);
    //             setSessionName(kq[0].session_name);
    //             setTimes(kq[0].times);
    //             setStartTime(kq[0].start_time);
    //         }
    //     // } else {
    //     //     setChoicesList([]);
    //     // }
    // }
    // const handleSubmit = async (e) => {
    //     e.preventDefault(); // Ngăn reload trang

    //     if (selectedId === null) {
    //         alert("⚠️ Vui lòng chọn một phương án trước khi gửi.");
    //         return;
    //     }
    //     // Gửi biểu quyết (ví dụ: gọi API hoặc lưu vào localStorage)
    //     //console.log("✅ Biểu quyết đã gửi với ID:", selectedId);
    //     const formData = new FormData();
    //     formData.append('session_id', sessionId);
    //     formData.append('vote_data', selectedId);
    //     formData.append('times', times);
    //     formData.append('start_time', start_time);
    //     try {
    //         // Ví dụ: gọi API đăng nhập
    //         const response = await window.fetchWithAuth("vote_sessions/vote", {
    //             method: "POST",
    //             body: formData,
    //         });
    //         const result = await response.json();
    //         if (result.code === 200) {
    //             //console.log("✅ Biểu quyết thành công:", result);
    //             // Có thể chuyển trang hoặc hiển thị thông báo
    //             toast.success(result.msg);
    //         } 
    //         if (result.code === 201 || result.code === 301) {
    //             //console.warn("❌ Biểu quyết thất bại:", result.message);
    //             toast.error(result.msg);
    //         }
    //     } catch (error) {
    //         console.error("⚠️ Lỗi khi gửi biểu quyết:", error);
    //     }
    // };
    async function getDashboard(flag = 0) {
        if (flag === 1) {
            try {
                const response = await window.fetchWithAuth(`dashboard/getDashboard/${flag}`);
                const results = await response.json();
                if (results.code === 401) {
                    navigate("/logout"); // Chuyển hướng nếu code là 401
                    return;
                } else {
                    setDataDB(results.data); // Cập nhật state
                    setDataSession(results.data_session);
                }
            } catch (error) {
                console.error("Lỗi khi gọi API:", error);
            }
         } 
    }
    const CountdownItem = ({ id, initialSeconds, statuss }) => { 
         const start = new Date(dataSession.start_time);
         const now = new Date();
          const status = dataSession.status;
         //const timeDifferenceInSeconds = Math.floor((now.getTime() - start.getTime()) / 1000);

        const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
        useEffect(() => {
            //setSecondsLeft(initialSeconds);
            // Chuyển đổi chuỗi thời gian sang đối tượng Date
            // // Tính toán số giây chênh lệch giữa thời gian kết thúc và hiện tại
            // // Đảm bảo thời gian hiện tại nằm trong khoảng thời gian của phiên
            const timeDifferenceInSeconds = initialSeconds - (Math.floor((now.getTime() - start.getTime()) / 1000));
            if (now >= start && timeDifferenceInSeconds <= initialSeconds && status === "2") {
                setSecondsLeft(timeDifferenceInSeconds);
            } else if (status === "1"){
                setSecondsLeft(initialSeconds);
            }else {
                setSecondsLeft(0); // Nếu phiên đã kết thúc hoặc chưa bắt đầu
                return;
            }
            if (initialSeconds <= 0) return;
            if (status === "1") return; // không chạy nếu chưa được kích hoạt
            if (status === "3") {
                setSecondsLeft(0);
                return;
            }
            const timer = setInterval(() => {
                //setSecondsLeft(prev => prev - 1);
                setSecondsLeft(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        ChangeStatus(id,3);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }, [status, initialSeconds]);
        // Đảm bảo secondsLeft không bao giờ âm
        const safeSecondsLeft = Math.max(0, secondsLeft);
        // 👉 Chuyển đổi sang phút và giây
        const minutes = Math.floor(safeSecondsLeft / 60);
        const seconds = safeSecondsLeft % 60;
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        return (
            <div style={{ fontSize: "14px", fontWeight: "bold", color: "white" }}>
            ⏳{formattedTime}
            </div>
        );
    };
    async function ChangeStatus(id, status) {
        const result = await window.fetchWithAuth("vote_sessions/changeStatus/" + id+"/"+status);
        const results = await result.json();
        if (results.code === 200) {
            let status_temp = status==="1"?2:status==="2"?1:3;
            setStatus(status_temp);
            getDashboard(1);
        }
    }
    return (
        <div className="">
            <div className="" style={{textAlign: "center"}}>
                {/* <div className="card" style={{justifyContent: "center"}}> */}
                    {/* <div className="card-header" style={{fontFamily: 'Tahoma', textAlign: "center", backgroundColor:"#27e257", color: "white"}}>
                        <b>KẾT QUẢ BIỂU QUYẾT</b><br/>
                        {dataSession.name?dataSession.name.toUpperCase():""}
                    </div> */}
                {/* <!-- /.card-header --> */}
                {/* <div className="card-body"> */}
                <div className="row" style={{fontFamily: 'Tahoma', justifyContent: "center"}}>
                    <div className="col-md-10">
                        <div className="card-header" style={{fontFamily: 'Tahoma', textAlign: "center", backgroundColor:"#27e257", color: "white"}}>
                            <label><b>KẾT QUẢ BIỂU QUYẾT</b></label><br/>
                            <div className="session-name">{dataSession.name?dataSession.name.toUpperCase():""}</div>
                        </div>
                            <table className="table" border={1}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>KẾT QUẢ</th>
                                        <th>TỶ LỆ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>THỜI GIAN</td>
                                        <td colSpan={2}>
                                            {dataSession.length!==0 && dataSession.status!=="3"?(
                                                <CountdownItem key={dataSession.id} id={dataSession.id} initialSeconds={dataSession.times*60} status={status}/>
                                            ):"Hết giờ"}
                                        </td>
                                    </tr>
                                    {dataDB.map((item, key) =>(
                                            <tr key={key}>
                                                <td>{item.name.toUpperCase()}</td>
                                                <td>{(item.id===0&&item.session_id===1&&(dataSession.status==="1"||dataSession.status==="2"))?"0":item.results}</td>
                                                <td>{(item.id!==0)||(item.id===0&&item.session_id===1&&dataSession.status==="3")?item.percentage+" %":(item.id===0&&item.session_id===0)?"":" 0 %"}</td>
                                            </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                            {
                                dataSession.status==="1"&&user.idOrganizeManage===1?(
                                    <button className="start-button" onClick={() => ChangeStatus(dataSession.id, dataSession.status)}>
                                        Bắt đầu
                                    </button>
                                )
                                :dataSession.status==="2"&&user.idOrganizeManage===1?(
                                    <div className="voting-status">Đang biểu quyết</div>
                                )
                                :dataSession.status==="3"&&user.idOrganizeManage===1?(
                                    <div className="end-status">Kết thúc</div>
                                )
                                :""
                            }
                        </div> 
                    </div>
                {/* </div> */}
                {/* </div> */}
            </div>
            <ToastContainer />
        </div>
    );
}
export default memo(Index);
